import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ToastContainer } from "react-toastify";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";

import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";

import CSupportImg from "@/assets/images/webp/customer-support-img.webp";
import CSupportHeightlight1 from "@/assets/images/webp/customer-support-key-highlight-1.webp";
import CSupportHeightlight2 from "@/assets/images/webp/customer-support-key-highlight-2.webp";
import CSupportHeightlight3 from "@/assets/images/webp/customer-support-key-highlight-3.webp";
import CSupportImg2 from "@/assets/images/webp/customer-support-comprehensive-business-assistance.webp";
import CSupportImg3 from "@/assets/images/webp/customer-support-global-relationship-management.webp";

const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  useEffect(() => {
    setSelectedLanguage(localStorage.getItem("web_lang"));
  }, []);

  return (
    <>
      <SeoHelmet
        title={seoConfig.customerSupport.title}
        description={seoConfig.customerSupport.description}
        keywords={seoConfig.customerSupport.keywords}
        author={seoConfig.customerSupport.author}
      />
      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>
      <div>
        <section className="customer-support">
          {/* inner banner wrape START  */}
          <div className="inner-banner">
            <div className="container">
              {
                (selectedLanguage === "en") ? <div className="content-wrape desk-hide">
                  <h2>
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Comprehensive</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Customer</motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Support</motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Always by Your Side</motion.p>
                </div> : <div className="content-wrape desk-hide">
                  <h2>
                    <span className={`light`}>Comprehensive</span>
                    <span className={`blue-text`}> Customer</span>
                    <span className={`black`}> Support</span>
                  </h2>
                  <p className={``}>Always by Your Side</p>
                </div>
              }
            </div>
          </div>
          {/* inner banner wrape END  */}

          {/* inner page content START */}
          <div className="inner-page-content-wrape global-trade-network-page">
            <div className='container'>
              {
                selectedLanguage === "en" ? <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Comprehensive</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Customer</motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Support</motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Always by Your Side</motion.p>
                </div> : <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <span className={`light`}
                    >Comprehensive</span>
                    <span className={`blue-text`}
                    > Customer</span>
                    <span className={`black`}
                    > Support</span>
                  </h2>
                  <p className={``}>Always by Your Side</p>
                </div>
              }


              <div className="subtext-wrape">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.h1 className={`animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Reliable Customer Assistance</motion.h1>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.p className={`medium-size animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Orex Trade provides dedicated, responsive customer support to help you navigate every stage of your trading journey. From onboarding to partner connections and market insights, our team ensures you receive reliable assistance whenever you need it.</motion.p>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                  <div className='img-wrape'>
                    <motion.img src={CSupportImg} alt='Customer Support' loading="lazy"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                      className="animate-child"
                    ></motion.img>
                  </div>
                </div>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                  <div className='content-wrape'>
                    <div className="head-text">
                      <motion.h2 className="head animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Customer Support
                      </motion.h2>
                    </div>

                    <motion.h6 className="varient animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Connect, Interact & Accelerate Growth</motion.h6>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      At Orex Trade World Inc, we believe great partnerships go beyond technology. They’re built on trust, guidance and support. Our Customer Support division  ensures every member receives personalized assistance, from onboarding to business expansion. Whether you need help connecting with reliable partners, understanding market trends or optimizing your trade activities, our expert team is always ready to help.
                    </motion.p>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      With a global presence and multilingual experts, Orex Trade ensures that every inquiry is handled quickly, efficiently and professionally empowering you to focus on what matters most: growing your business with confidence.
                    </motion.p>
                  </div>
                </div>
              </div>

              {/* verification global network START */}
              <div className="verification-global-wrape" id="membership-support">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="head-text center">
                      <motion.h2 className="head center animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Dedicated Membership Support
                      </motion.h2>
                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Our Dedicated Membership Support team is the backbone of Orex Trade’s service excellence. We offer personalized guidance to help members maximize their experience from setting up profiles and managing listings to selecting verified trade partners.</motion.p>

                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Our customer support experts are available across multiple communication channels to resolve queries quickly and efficiently. With prompt responses, proactive outreach and a member-first approach, Orex Trade ensures your business experience remains smooth, reliable and result-driven.</motion.p>
                    </div>
                  </div>

                  <div className="col-xxl-12">
                    <motion.h5 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Key Highlights</motion.h5>
                    <div className="row custom-scroll-row">
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={CSupportHeightlight1} alt='Personalized onboarding and member guidance' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Personalized onboarding and member guidance</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={CSupportHeightlight2} alt='Fast and responsive support across multiple channels' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Fast and responsive support across multiple channels</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={CSupportHeightlight3} alt='Expert help in finding and connecting with partners' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Expert help in finding and connecting with partners</motion.p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* verification global network END */}
            </div>


            {/* globalPartnerwrape START */}
            <div className="global-partner-wrape" id="business-assistance">
              <div className="img-wrape">
                <motion.img src={CSupportImg2} alt='Comprehensive Business Assistance' loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail-wrape">
                <div className="inner-pad">
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Comprehensive Business Assistance
                    </motion.h2>
                  </div>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >We don’t just answer questions - we help you grow. Through Comprehensive Business Assistance, our senior trade advisors regularly connect with members to understand their goals and challenges. We offer customized advice on expanding into new markets, selecting the right logistics partners and marketing your business effectively.</motion.p>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Whether you’re scaling your operations or exploring new trade lanes, Orex Trade provides continuous strategic support. Our goal is to help your business thrive globally by combining deep market knowledge with practical, growth-oriented guidance.</motion.p>
                  <motion.h5
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Key Highlights</motion.h5>
                  <ul>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Expert recommendations for business expansion
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Guidance on marketing, trade lanes and partnerships
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Global trade insights and personalized consultations
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Strategic support tailored to your business goals
                    </motion.li>
                  </ul>
                </div>
              </div>
            </div>
            {/* globalPartnerwrape END */}

            {/* market-inteligence-wrape START */}
            <div className="container market-inteligence-wrape" id="relationship-management">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div className="detail-wrape">
                    <div className="inner-pad">
                      <div className="head-text">
                        <motion.h2 className="head animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          Global Relationship Management
                        </motion.h2>
                      </div>
                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >At Orex Trade, support means partnership. Our Global Relationship Management team focuses on building strong, lasting connections with every member. By maintaining direct communication with businesses worldwide, we ensure you’re never alone in your trade journey.</motion.p>

                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >From partner introductions to local market insights, our specialists provide valuable recommendations that foster collaboration and trust. With Orex Trade by your side, you gain not just a support team but a global network that grows with you.</motion.p>
                      <div className="clearfix"></div>
                      <motion.h5 className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Key Highlights</motion.h5>
                      <ul>
                        <motion.li
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                          className="animate-child"
                        >
                          <i className="sprite"></i>
                          Personalized relationship management for all members
                        </motion.li>
                        <motion.li
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                          className="animate-child"
                        >
                          <i className="sprite"></i>
                          Regular follow-ups and growth-focused communication
                        </motion.li>
                        <motion.li
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Local market insights and partner introductions
                        </motion.li>
                        <motion.li
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                          className="animate-child"
                        >
                          <i className="sprite"></i>
                          Strengthens long-term global trade relationships
                        </motion.li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <motion.img src={CSupportImg3} alt='Global Relationship Management' loading="lazy"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                    className="animate-child"
                  ></motion.img>
                </div>
              </div>
            </div>
            {/* market-inteligence-wrape END */}

            {/* gray wrape START */}
            <div className="gray-wrape">
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12">
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >With Orex Trade’s Customer Support, you gain more than assistance, you gain a dedicated team committed to your success. Our Membership Support, Business Assistance and Relationship Management services ensure you have expert guidance every step of the way.</motion.p>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Orex Trade - Always by Your Side, Helping You Grow Globally.</motion.p>
                  </div>
                </div>
              </div>
            </div>
            {/* gray wrape END */}

          </div>
          {/* inner page content END */}
        </section>
      </div>
      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        // onSubmit={handleRegistrationPopup}
        // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
        // }
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </>
  );
};

export default Index;